import React from 'react';
import { Container, Row, Col, Alert, Image } from 'react-bootstrap';
import ContentListComponent from '../components/ContentListComponent';
import ContentTypeCacheComponent from '../components/ContentTypeCacheComponent';
import LibraryAdmin from '../components/LibraryAdminComponent';
import Login from '../components/Login';
import { ContentService } from '../services/ContentService';

interface LoginData {
    username: string;
    name: string;
    email: string;
    csrfToken?: string;
}

interface HomePageProps {
    contentService: ContentService;
    loggedIn: boolean;
    onLoggedIn: (loginData?: LoginData) => void;
    onLoggedOut: () => void;
}

const HomePage: React.FC<HomePageProps> = ({
    contentService,
    loggedIn,
    onLoggedIn,
    onLoggedOut
}) => {
    return (
        <div>
            <Container>
                <Row>
                    <Col md={10}>
                        <h1>VMB H5P Editor</h1>
                    </Col>
                    <Col md={2}>
                        <Image
                            src="/vmblogo.jpg"
                            alt="logo"
                            style={{
                                width: '80px',
                                height: 'auto',
                                borderRadius: '50%'
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Login
                            contentService={contentService}
                            onLoggedIn={onLoggedIn}
                            onLoggedOut={onLoggedOut}
                        />
                    </Col>
                </Row>
            </Container>
            <Container className="full-page-left">
                {loggedIn && (
                    <>
                        <ContentListComponent
                            contentService={contentService}
                        ></ContentListComponent>
                        <ContentTypeCacheComponent
                            endpointUrl={
                                process.env.REACT_APP_H5P_SERVER_API_URL +
                                '/h5p/content-type-cache'
                            }
                        ></ContentTypeCacheComponent>
                        <LibraryAdmin
                            endpointUrl={
                                process.env.REACT_APP_H5P_SERVER_API_URL + '/h5p/libraries'
                            }
                        ></LibraryAdmin>
                    </>
                )}
            </Container>
        </div>
    );
};

export default HomePage;

